// extracted by mini-css-extract-plugin
export default {"viewItem":"view-form_viewItem__-A8SC","viewItemValue":"view-form_viewItemValue__WTpRN"};